"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SimpleHeaderDesktop = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _userUtils = require("../header/userUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    header: {
      height: 64
    },
    logo: {
      padding: 0
    },
    primaryText: {
      color: theme.palette.text.primary,
      width: 200
    },
    secondaryText: {
      color: theme.palette.text.secondary,
      fontSize: 14
    },
    avatar: {
      position: 'absolute',
      right: 0,
      padding: 0,
      marginLeft: 24,
      marginRight: 24
    },
    menu: {
      marginTop: 48
    },
    menuAvatar: {
      marginRight: 16
    },
    menuIcons: {
      marginRight: 24,
      marginLeft: 8
    },
    menuItemText: {
      color: theme.palette.text.primary,
      width: 200,
      fontSize: 14
    }
  };
});

var SimpleHeaderDesktop = function SimpleHeaderDesktop(_ref) {
  var username = _ref.username,
      email = _ref.email,
      onClickHome = _ref.onClickHome,
      onExit = _ref.onExit,
      logo = _ref.logo;
  var classes = useStyles();
  var initials = (0, _userUtils.getInitials)(username);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var open = Boolean(anchorEl);

  var handleMenu = function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  function renderMenu() {
    return /*#__PURE__*/_react.default.createElement(_core.Menu, {
      className: classes.menu,
      anchorEl: anchorEl,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      open: open,
      onClose: handleClose
    }, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      style: {
        marginTop: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: classes.menuAvatar
    }, initials), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.primaryText
    }, (0, _userUtils.listUser)(username, 24), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.secondaryText
    }, (0, _userUtils.listUser)(email, 28)))), /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      onClick: onExit
    }, /*#__PURE__*/_react.default.createElement(_icons.ExitToApp, {
      style: {
        marginRight: 24,
        marginLeft: 8
      }
    }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.menuItemText
    }, "Sair")));
  }

  function renderAvatar() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      className: classes.avatar,
      onClick: handleMenu
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, null, initials)), renderMenu());
  }

  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.logo,
    onClick: onClickHome
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxHeight: 40
    },
    src: logo,
    alt: "logo"
  })), renderAvatar()));
};

exports.SimpleHeaderDesktop = SimpleHeaderDesktop;
SimpleHeaderDesktop.propTypes = {
  /**
   * Nome do usuário exibido ao clicar no menu
   */
  username: _propTypes.default.string,

  /**
   * Email do usuário exibido ao clicar no menu
   */
  email: _propTypes.default.string,

  /**
   * Função requerida para quando o usuário clicar no logotipo presente no header.
   */
  onClickHome: _propTypes.default.func.isRequired,

  /**
   * Logo que aparecerá no topo da página
   */
  logo: _propTypes.default.element.isRequired
};
SimpleHeaderDesktop.propTypes = {
  username: _propTypes.default.string.isRequired,
  email: _propTypes.default.string.isRequired,
  onClickHome: _propTypes.default.func.isRequired,
  onExit: _propTypes.default.func.isRequired
};
var _default = SimpleHeaderDesktop;
exports.default = _default;